var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSemicircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1215 607",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        letter-spacing: .12em;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #8accff;\r\n      }\r\n\r\n      .cls-2, .cls-3, .cls-4, .cls-5 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-6 {\r\n        letter-spacing: .02em;\r\n      }\r\n\r\n      .cls-7 {\r\n        letter-spacing: .02em;\r\n      }\r\n\r\n      .cls-8, .cls-9 {\r\n        font-size: 39.17px;\r\n      }\r\n\r\n      .cls-8, .cls-9, .cls-10, .cls-11 {\r\n        font-weight: 700;\r\n      }\r\n\r\n      .cls-8, .cls-9, .cls-11 {\r\n        font-family: Gilroy-Bold, Gilroy-Bold;\r\n      }\r\n\r\n      .cls-8, .cls-11 {\r\n        fill: #000;\r\n      }\r\n\r\n      .cls-12 {\r\n        letter-spacing: .02em;\r\n      }\r\n\r\n      .cls-3, .cls-13 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-14 {\r\n        letter-spacing: .06em;\r\n      }\r\n\r\n      .cls-15 {\r\n        letter-spacing: -.07em;\r\n      }\r\n\r\n      .cls-9, .cls-5 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-16 {\r\n        letter-spacing: 0em;\r\n      }\r\n\r\n      .cls-4, .cls-10 {\r\n        fill: #1063a5;\r\n      }\r\n\r\n      .cls-17 {\r\n        clip-path: url(#clippath);\r\n      }\r\n\r\n      .cls-13 {\r\n        stroke: #3d4791;\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 2px;\r\n      }\r\n\r\n      .cls-18 {\r\n        letter-spacing: .02em;\r\n      }\r\n\r\n      .cls-19 {\r\n        letter-spacing: 0em;\r\n      }\r\n\r\n      .cls-20 {\r\n        letter-spacing: .11em;\r\n      }\r\n\r\n      .cls-10 {\r\n        font-family: AkiraExpanded-SuperBold, 'Akira Expanded';\r\n        font-size: 43px;\r\n      }\r\n\r\n      .cls-11 {\r\n        font-size: 48.82px;\r\n      }\r\n\r\n      .cls-21 {\r\n        letter-spacing: 0em;\r\n      }\r\n\r\n      .cls-22 {\r\n        letter-spacing: .01em;\r\n      }\r\n\r\n      .cls-23 {\r\n        letter-spacing: .05em;\r\n      }\r\n\r\n      .cls-24 {\r\n        letter-spacing: 0em;\r\n      }\r\n\r\n      .cls-25 {\r\n        letter-spacing: .04em;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 1215,
    height: 607
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M954.33,112.43c-34.8,67.11-89.82,124.12-160.89,160.92-10.59,5.49-15.24,18.15-10.68,29.17l81.46,196.7c5.06,12.21,19.34,17.59,31.25,11.86,134.07-64.46,236.04-170.82,296.59-296.61,5.7-11.84.18-26.03-11.95-31.06l-196.7-81.49c-10.96-4.54-23.63-.02-29.09,10.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M720.79,304.53c-76.28,24.22-155.5,22.8-227.56-.05-11.3-3.59-23.46,2.18-28,13.14l-81.49,196.71c-5.03,12.13,1.11,26.07,13.51,30.42,131.76,46.15,279.07,49.27,419.46.06,12.48-4.37,18.77-18.27,13.71-30.49l-81.46-196.7c-4.56-11.02-16.8-16.69-28.17-13.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M420.9,273.45c-67.15-34.77-124.2-89.79-161.04-160.86-5.49-10.59-18.15-15.23-29.16-10.67L34,183.4c-12.22,5.06-17.59,19.34-11.86,31.26,64.5,134.07,170.91,236.03,296.75,296.55,11.83,5.69,26.03.17,31.05-11.96l81.48-196.69c4.54-10.96.01-23.64-10.52-29.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M923.24.53c-18.44,156.03-152.95,277.13-316.16,277.13S309.36,156.56,290.92.53h632.32Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-11",
    transform: "translate(387.81 93.51)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 0,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 29.73,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 58.88,
    y: 0
  }, "al E"), /*#__PURE__*/React.createElement("tspan", {
    x: 143.48,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21",
    x: 166.18,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 184.83,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21",
    x: 216.37,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 235.02,
    y: 0
  }, "e "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 277.54,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 313.71,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-24",
    x: 345.25,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 362.68,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 391.83,
    y: 0
  }, "er")), /*#__PURE__*/React.createElement("text", {
    className: "cls-10",
    transform: "translate(410.59 147.25) scale(.97 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 0,
    y: 0
  }, "F"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-22",
    x: 32.18,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-25",
    x: 76.94,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 117.93,
    y: 0
  }, "t-"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 192.48,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 235.68,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 276.74,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-20",
    x: 320.65,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 364.78,
    y: 0
  }, "k"))), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(145.88 166.88) rotate(65.81)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "R")), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(156.51 190.15) rotate(63.71)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "i")), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(161.33 200.17) rotate(61.59)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "g")), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(173.9 223.27) rotate(58.71)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "h")), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(186.55 243.87) rotate(56.38)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "t")), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(195.68 257.51) rotate(54.82)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(202.08 266.75) rotate(52.78)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "P")), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(216.34 285.44) rotate(50.39)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "s")), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(228.29 299.9) rotate(48.13)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "y")), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(242.58 315.82) rotate(45.67)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "c")), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(258.32 331.92) rotate(43.01)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "h")), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(276.14 348.5) rotate(40.2)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "o")), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(295.16 364.38) rotate(38.15)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "l")), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(303.84 371.32) rotate(36.1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "o")), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(324.09 386.06) rotate(33.17)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "g")), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(346.1 400.34) rotate(30.39)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "y")), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(365.16 411.39) rotate(28.49)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(374.83 416.62) rotate(27.23)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(384.62 421.64) rotate(25.97)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(394.52 426.45) rotate(24.71)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(404.51 431.04) rotate(23.45)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(414.61 435.4) rotate(22.19)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(424.79 439.54) rotate(20.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(435.08 443.46) rotate(19.69)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(445.43 447.16) rotate(18.44)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(456.07 450.81) rotate(16.35)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "R")), /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(480.65 457.86) rotate(14.28)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "i")), /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(491.4 460.71) rotate(12.2)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "g")), /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(516.93 466.17) rotate(9.4)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "h")), /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(540.83 470.02) rotate(7.12)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "t")), /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(557.1 472) rotate(5.57)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(568.26 473.18) rotate(3.56)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "S")), /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(592.05 474.57) rotate(1.29)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "t")), /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(608.5 474.91) rotate(-.52)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "r")), /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(623.23 474.87) rotate(-2.81)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "a")), /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(649.37 473.45) rotate(-5.26)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "t")), /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(664.99 472.08) rotate(-7.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "e")), /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(689.14 468.89) rotate(-10.39)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "g")), /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(714.74 464.03) rotate(-12.52)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "i")), /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(725.59 461.71) rotate(-14.54)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "e")), /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(748.43 455.72) rotate(-16.98)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "s")), /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(767.16 449.92) rotate(-18.73)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(777.58 446.37) rotate(-19.98)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(787.92 442.6) rotate(-21.24)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(798.16 438.6) rotate(-22.49)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(808.31 434.39) rotate(-23.74)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(818.38 429.95) rotate(-24.99)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(828.33 425.29) rotate(-26.24)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(838.2 420.41) rotate(-27.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(847.95 415.32) rotate(-28.75)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(857.59 410.02) rotate(-29.99)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(867.1 404.52) rotate(-31.24)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(876.49 398.81) rotate(-32.49)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(886.02 392.86) rotate(-34.58)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "R")), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(906.99 378.21) rotate(-36.67)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "i")), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(916 371.64) rotate(-38.79)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "g")), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(936.45 355.13) rotate(-41.68)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "h")), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(954.45 338.95) rotate(-44.01)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "t")), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(966.21 327.52) rotate(-45.58)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(974.14 319.55) rotate(-47.63)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "S")), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(990.08 302.02) rotate(-50.22)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "y")), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(1003.43 285.94) rotate(-52.49)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "s")), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(1014.92 270.91) rotate(-54.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "t")), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(1024.1 258.17) rotate(-56.76)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "e")), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(1037.72 237.58) rotate(-60.24)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "m")), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(1055.01 206.81) rotate(-63.45)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "s")), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 497.45,
    y1: 179.87,
    x2: 716.72,
    y2: 179.87
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSemicircle);
export default __webpack_public_path__ + "static/media/semicircle.cc692c3544721f60a0b573c8fb49d922.svg";
export { ForwardRef as ReactComponent };